module.exports = __webpack_public_path__ + "img/2_1.8424194c.png";